module.exports = __webpack_public_path__ + "img/02-7.de7bed2c.png";